import { useMutation } from '@tanstack/react-query';
import httpv2 from 'apis/httpv2';
import { MutationConfig, TransactionTypeDto } from 'types';

const putTransactionType = ({ id, data }: { id: string; data: TransactionTypeDto }) => {
  return httpv2.put<TransactionTypeDto>(`/transaction-types/${id}`, data);
};

interface UseTransactionTypeOptions {
  mutationConfig?: MutationConfig<typeof putTransactionType>;
}

export const useUpdateTransactionType = ({ mutationConfig }: UseTransactionTypeOptions) => {
  const config = mutationConfig || {};

  return useMutation({
    ...config,
    mutationFn: putTransactionType,
  });
};
